import { css } from '@emotion/css';

export const flexSplitHorizontalInHalf = css`
  display: flex;
  justify-content: space-between;
  gap: 15px;
  > * {
    flex: 1;
  }
`;

export const flexSpacedRowWithVerticalCenter = [
  css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  `,
].join(' ');

export const flexRightmostItemRow = [
  css`
    display: flex;
    flex-direction: row;
    justify-content: end;
  `,
].join(' ');

export const CancelButtonStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 48px;
  background-color: #55a9f3 !important;
  border-radius: 5px;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
  border: none;
  cursor: pointer;
  margin-top: 15px;

  &:disabled {
    background: #d3d3d6 !important;
    cursor: not-allowed;
  }
`;

export const billTitle = css`
  font-weight: 700;
  font-size: 22px;
  line-height: 22px;
  color: #1e1e1e;
`;

export const billRow = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const billLabel = css`
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: #1e1e1e;
`;

export const billValue = css`
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-align: right;
  color: #1e1e1e;
`;

export const billSubLabel = css`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #9f9f9f;
`;

export const billSubValue = css`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  text-align: right;
  color: #9f9f9f;
`;

export const billTotalLabel = css`
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: #1e1e1e;
`;

export const billTotalValue = css`
  font-weight: 700;
  font-size: 25px;
  line-height: 22px;
  text-align: right;
  color: #1e1e1e;
`;

export const billDivider = css`
  border-top: 1px solid #d3d3d6;
  width: 100%;
`;
